/**
 * The design system's semantic color roles (docs/design-system.md §3.2.3)
 * the message bodies are drawn in, until an `@euler/design` module exports
 * them. Name a role here, not a hex at the call site.
 */
export const designRoles = {
  textPrimary: '#1F2937',
  textSecondary: '#64748B',
  textTertiary: '#94A3B8',
  textInverse: '#FFFFFF',
  bgSurface: '#FFFFFF',
  bgSunken: '#F1F5F9',
  borderDefault: '#E2E8F0',
  borderStrong: '#CED1D9',
  interactive: '#2669db',
  statusDanger: '#e0463d',
};
